/* eslint-disable no-await-in-loop */
import axios from 'axios';
import { Product } from './models';
import * as MutationTypes from './mutationTypes';

export const getNextPageProducts = async (commit, nextProductsUrl, cancelToken, pointOfSaleGuid) => {
  let nextPageUrl = nextProductsUrl;
  while (nextPageUrl) {
    try {
      const response = await axios.get(nextPageUrl, { removeTrailingSlash: true, cancelToken });
      const { count, results } = response.data;
      const productList = Product.toInstanceList(results);
      commit(MutationTypes.MASTER_PRODUCT_LIST_UPDATE, { productList, count, pointOfSaleGuid });
      nextPageUrl = response.data.next;
    } catch (error) {
      nextPageUrl = null;
      if (!axios.isCancel(error)) throw error;
    }
  }
};
